export default __webpack_public_path__ + "static/media/service-qr-code.9a7c9543.svg";